import React, { useEffect, useState } from 'react';
import { Spin, Empty } from 'antd';
import { find, sortBy, get, filter } from 'lodash';
import FilterComponent from './filterComponent';
import ProfileAndPeerGraph from './ProfileAndPeerGraph';
import PopoutWindow from '../../../../components/PopoutWindow';
import { ImportanceLabel, LoadingWrapper, PopoutHead } from '../styled';
import style from './index.scss';

export const ProfileAndPeerComparison = ({
  apiActions,
  settings,
  peerProfileGraph,
  alertDetails,
  alertId,
  ...props
}) => {
  const {
    getPeerAndProfileGraph,
    getTypologyList,
    getRiskIndicatorListByTypologyId
  } = apiActions;
  const { typologyList, riskIndicatorList } = props;

  let dataUrlMap = {};

  const modelId = alertDetails?.modelId;
  const clusterId = alertDetails?.clusterId;

  const [isPopedOut, setIsPopedOut] = useState(false);
  const [typologyId, setTypologyId] = useState(null);
  const [typologyListOptionsList, setTypologyListOptions] = useState([]);
  const [riskIndicatorIds, setRiskIndicatorIds] = useState(null);
  const [riskIndicatorInnerList, setRiskIndicatorInnerList] = useState(null);
  const [riskIndicatorLabelIndex, setRiskIndicatorLabelIndex] = useState(0);

  useEffect(() => {
    // Typology filter API By AlertId
    alertId && getTypologyList({ alertId });
  }, [alertId]);

  useEffect(() => {
    getDropdownItems();

    typologyList && setTypologyId(typologyList?.[0]?.id);
  }, [typologyList]);

  useEffect(() => {
    // calling Risk Indicator list based on typology API
    typologyId &&
      alertId &&
      modelId &&
      getRiskIndicatorListByTypologyId({ typologyId, alertId, modelId });
  }, [typologyId, alertId, modelId]);

  useEffect(() => {
    // if (riskIndicatorList && riskIndicatorList.length && !riskIndicatorIds) {
    if (riskIndicatorInnerList !== riskIndicatorList && !riskIndicatorIds) {
      const riskIndicatorSortedList = sortBy(
        riskIndicatorList,
        'riskIndicatorRank'
      );

      const riskId = get(riskIndicatorSortedList, '0.riskIndicatorId', '');
      setRiskIndicatorInnerList(riskIndicatorList);
      setRiskIndicatorIds(`${riskId},`);
    }

    if (riskIndicatorIds && alertId && typologyId && modelId && clusterId) {
      getPeerAndProfileGraph({
        alertId,
        typologyId,
        modelId,
        clusterId,
        riskIndicatorIds
      });
    }
  }, [
    alertId,
    typologyId,
    modelId,
    clusterId,
    riskIndicatorIds,
    riskIndicatorList
  ]);

  const riskIndicatorIdsChangeHandler = (riskIndicatorIds) => {
    setRiskIndicatorIds(`${riskIndicatorIds},`);
  };

  // onSelect Typology
  const typologyIdChangeHandler = (typologyId) => {
    setTypologyId(typologyId);

    setRiskIndicatorLabelIndex(0);
    setRiskIndicatorIds(null);
  };

  const getDropdownItems = () => {
    if (!typologyList) return;

    const selectOptionsList = [typologyList]
      .flat()
      .map((item) => ({ label: item.name, value: item.id, key: item.id }));

    setTypologyListOptions(selectOptionsList);
  };

  const getSortedRiskIndicatorList = () => {
    if (!riskIndicatorList.length) return;

    return sortBy(riskIndicatorList, 'riskIndicatorRank');
  };

  const togglePopout = () => {
    ['deviation'].forEach((title) => {
      let querySelector = `img[title='${title}']`;
      let image = document.querySelector(querySelector);
      if (image) {
        const canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        canvas.getContext('2d').drawImage(image, 0, 0);
        dataUrlMap[title] = canvas.toDataURL('image/png');
      }
    });

    setIsPopedOut(!isPopedOut);
  };

  const getRiskIndicatorNameById = (id) => {
    let obj = find(riskIndicatorList, (o) => id == o.riskIndicatorId);
    return obj?.riskIndicatorName;
  };

  const renderPopoutWindowContent = () => {
    return (
      <div>
        {peerProfileGraph?.data !== null &&
        peerProfileGraph?.data.length > 0 ? (
          peerProfileGraph?.data.map((item, index) => {
            return (
              <div style={{ padding: '16px' }}>
                <PopoutHead>
                  {getRiskIndicatorNameById(item.riskIndicatorId)}
                  <ImportanceLabel>
                    <span
                      style={{
                        whiteSpace: 'nowrap',
                        width: '88px',
                        display: 'inline-flex'
                      }}>
                      Importance:{' '}
                      <b>
                        {item.importance
                          ? Math.round(
                              (item.importance + Number.EPSILON) * 100
                            ) / 100
                          : '-'}
                      </b>
                    </span>
                  </ImportanceLabel>
                </PopoutHead>
                <ProfileAndPeerGraph
                  peerProfileGraph={item}
                  key={index}
                  {...riskIndicatorList[index]}
                />
              </div>
            );
          })
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </div>
    );
  };

  return (
    <div className={style.container}>
      {peerProfileGraph.isLoading ? (
        <LoadingWrapper>
          {riskIndicatorIds ? (
            <Spin size="large" />
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}
        </LoadingWrapper>
      ) : typologyList.length > 0 && riskIndicatorList.length > 0 ? (
        <React.Fragment>
          <div className={style.filerHead}>
            {typologyList && (
              <FilterComponent
                typologyList={typologyList}
                riskIndicatorList={getSortedRiskIndicatorList()}
                alertId={alertId}
                modelId={modelId}
                typologyIdChangeHandler={typologyIdChangeHandler}
                typologyListOptionsList={typologyListOptionsList}
                riskIndicatorLabelIndex={riskIndicatorLabelIndex}
                setRiskIndicatorLabelIndex={setRiskIndicatorLabelIndex}
                peerProfileGraph={peerProfileGraph}
                setIsPopedOut={setIsPopedOut}
                riskIndicatorIdsChangeHandler={riskIndicatorIdsChangeHandler}
                typologyId={typologyId}
              />
            )}
          </div>
          {peerProfileGraph.data !== null &&
          peerProfileGraph.data.length > 0 ? (
            <ProfileAndPeerGraph
              peerProfileGraph={peerProfileGraph?.data[0]}
              {...riskIndicatorList[0]}
            />
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}
        </React.Fragment>
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}

      {isPopedOut && (
        <PopoutWindow
          onPopupOutClose={togglePopout}
          title={
            alertId +
            ' ' +
            filter(typologyList, (obj) => obj.id == typologyId)[0]?.name
          }
          width={window.innerWidth}
          height={900}
          imageUrlMap={dataUrlMap}>
          <div>{renderPopoutWindowContent()}</div>
        </PopoutWindow>
      )}
    </div>
  );
};

export default ProfileAndPeerComparison;
